import Vue from 'vue'
import Router from 'vue-router'

// Pages
import home from './home'
import login from './login'
import map from './map'
import fullmap from './fullmap'
import troubleshootingTools from './troubleshooting_tools'
import dataMonitor from './data_monitor'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    ...login,
    ...home,
    ...map,
    ...fullmap,
    ...troubleshootingTools,
    ...dataMonitor
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js